module.exports = __webpack_public_path__ + "static/media/players-journey.f87fc06e.png";